import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Saguaro } from "@/components/Saguaro";
import api from "@/lib/api";

export const LegalLayout = ({ title, updated, children }) => {
  const [prop, setProp] = useState(null);
  useEffect(() => { api.get("/property").then((r) => setProp(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-background">
      <div className="border-b border-border bg-card">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-serif text-xl font-semibold text-foreground">
            <Saguaro className="h-6 w-6 text-primary" /> {prop?.name || "The East Valley"}
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1"><ArrowLeft className="h-4 w-4" /> Back to site</Link>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <h1 className="font-serif text-4xl font-semibold text-foreground mb-2">{title}</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: {updated}</p>
        <div className="prose-legal space-y-5 text-sm leading-relaxed text-muted-foreground [&_h2]:text-foreground [&_h2]:font-semibold [&_h2]:text-lg [&_h2]:mt-8 [&_h2]:mb-2 [&_strong]:text-foreground">
          {typeof children === "function" ? children(prop) : children}
        </div>
      </div>
    </div>
  );
};
